/* istanbul ignore file */

export enum SiteFieldsNumericIds {
    SiteId = "0",
    SiteNumber = "1",
    SiteName = "2",
    Address = "3",
    City = "4",
    State = "5",
    ZipCode = "6",
    Status = "7",
    Coordinates = "8",
}
